export function Confetti() {
  return <div className="confetti" aria-hidden="true">{Array.from({ length: 60 }, (_, index) => <i key={index} style={{ '--x': `${(index * 47) % 100}%`, '--delay': `${(index % 10) * 0.05}s`, '--spin': `${(index % 7) * 45}deg` } as React.CSSProperties} />)}</div>;
}
